// extracted by mini-css-extract-plugin
export default {"visuallyhidden":"external-url-meatball__visuallyhidden--Idcgz","focusable":"external-url-meatball__focusable--FCydM","meatball":"external-url-meatball__meatball--q5Nen"};